import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Comment } from 'src/app/core/interfaces/movie.model';
import { Account } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-review',
  templateUrl: './modal-review.component.html',
  styleUrls: ['./modal-review.component.scss']
})
export class ModalReviewComponent implements OnInit, OnChanges {
  @Input() review: Comment;
  @Output() onClose = new EventEmitter<any>();
  @Input() invert: boolean = false;

  loading: Boolean = false;
  canReply: Boolean = false;
  loggedAccount: Account;

  replies: Comment[] = [];

  commentForm: FormGroup;

  constructor(private moviesService: MoviesService, private accountService: AccountService,
    private authService: AuthService,) {
    this.commentForm = new FormGroup({
      comment: new FormControl(""),
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.review.currentValue) {
      this.loadReplies();
      this.checkCanReply();
    }
  }

  ngOnInit(): void {
    console.log("REVIEWE SELECTED", this.review);
  }

  authorFullName(review: Comment) {
    return review.author.firstName + " " + review.author.lastName || "";
  }

  pictureDefault() {
    let pic = this.review.movie.pictures.find(p => p.isDefault);
    let link = pic.pictureLinkFull = "/movie/GetImage/" + pic.pictureId;

    return environment.apiEndpoint + link;
  }

  onClickEnviar() {
    this.loading = true;

    let newComment: Comment = {
      userId: this.loggedAccount.id,
      MovieId: this.review.movie.id,
      createdTime: new Date(moment().format('YYYY-MM-DDTHH:mm:ss')),
      comment: this.commentForm.get("comment").value,
      State: 1,
      ParentId: this.review.id,
      isReview: false,
      score: 0,
    }

    this.moviesService.publishComment(newComment).subscribe((res) => {
      Swal.fire({
        icon: 'success',
        text: "Comentario publicado correctamente.",
        confirmButtonText: 'Ok',
        confirmButtonColor: 'green'
      })
      this.commentForm.get("comment").setValue("");
      this.loadReplies();
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
      () => this.loading = false
    );
  }

  checkCanReply() { //COMPRUEBA QUE ESTES LOGEADO Y CARGA TODO.
    let estado = this.authService.getUserLogged();
    if (estado == true) {
      this.accountService.getAccountNoRedirect().then(
        (res: Account) => {
          if (res) {
            if (res == null) {
              //NO LOGEADO
              this.canReply = estado;
            }
            else {
              //LOGEADO
              this.loggedAccount = res;
              this.canReply = estado;
            }
          }
        },
        (error) => {
          //ERROR - NO LOGEADO
          this.canReply = estado;
        },
      );
    }
  }

  loadReplies() {
    this.loading = true;
    this.moviesService.getCommentReplies(this.review.id).subscribe((res) => {
      this.replies = res;
      this.replies.forEach(r => {
        r.formatedTime = moment(r.createdTime).format("DD-MM-YYYY");
        r.author.fullName = r.author.firstName + " " + r.author.lastName;
      });
      this.loading = false;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
        this.loading = false;
      },
    );
  }

  close() {
    this.onClose.emit();
    this.commentForm.get("comment").setValue("");
  }
}
